import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useIsDesktop } from '../../../mq/esm';
import { Title } from '../title/index.js';
import { TitleMobile } from '../title-mobile/component.js';
import '../title/component.js';
import 'react-merge-refs';
import 'classnames';
import '../hooks/use-skeleton.js';
import '../../../skeleton/esm';
import '@alfalab/hooks';
import '../title/utils.js';
import '../colors.module-113b9747.js';
import '../common.module-aa1a707c.js';

var TitleResponsive = forwardRef(function (_a, ref) {
    var breakpoint = _a.breakpoint, client = _a.client, restProps = __rest(_a, ["breakpoint", "client"]);
    var isDesktop = useIsDesktop(breakpoint, client === 'desktop');
    var Component = isDesktop ? Title : TitleMobile;
    return React.createElement(Component, __assign({}, restProps, { ref: ref }));
});

export { TitleResponsive };
